export default __webpack_public_path__ + "static/media/arrow.10a4d1ed.svg";